<template>
  <div class="tour-container"> 
    <!-- <video
      id="vid1"
      ref="vid"
      class="video-js vjs-default-skin md-layout tour-content"
      controls
      autoplay
      :data-setup="playerOptions"
    /> -->
    <youtube
      ref="vid"
      class="md-layout tour-content video-tour"
      video-id="bpGHiis3pzQ"
      :player-vars="time"
      @ready="ready"
    />
    <md-button
      class="md-primary primary-button studio-tour-button"
      @click="goToStudio"
    >
      Logout & <br> View Studio Info
    </md-button>
    <div class="kabs-chapter">
      <md-list :md-expand-single="true">
        <md-list-item
          md-expand
          :md-expanded.sync="expandNews"
        >
          <md-icon>list</md-icon>
          <span
            class="md-list-item-text"
            @click="scrollDown"
          >Studio Chapters</span>

          <md-list slot="md-expand">
            <template v-for="(chapter, index) in chapters">
              <md-list-item
                :key="index"
                class="md-inset"
              >
                <div class="md-layout md-layout-item">
                  <span><a @click="seekTo(chapter.time)">{{ chapter.timestamp }}</a> {{ chapter.title }}</span>
                </div>
              </md-list-item> 
            </template>
          </md-list>
        </md-list-item>
      </md-list>
    </div>
    <div>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer"
export default {
  name: "Login",
  components: {
    Footer
  },
  data () {
    return {
      playerOptions: '{ "techOrder": ["youtube"],"sources": [{ "type": "video/youtube","src": "https://www.youtube.com/watch?v=apOcm8mfrAw"}]}',
      time: {time: 0, autoplay: 1},
      player: {},
      expandNews: false,
      chapters: [
        {
          title: 'Intro KAB20',
          timestamp: '00:00',
          time: 0
        },
        {
          title: 'Hold up half the sky – Dana Whabira',
          timestamp: '02:03',
          time: 123
        },
        {
          title: 'Returning to what is flowing away – Laurence Bonvin',
          timestamp: '36:32',
          time: 2192
        },
        {
          title: 'The lost house – Maurice Pefura',
          timestamp: '01:09:57',
          time: 4197
        },
        {
          title: 'Rock starra – Tracey Rose',
          timestamp: '01:15:20',
          time: 4520
        },
        {
          title: 'Fanya kazi – Lilian Mary Nabulime',
          timestamp: '03:07:42',
          time: 11262
        },
        {
          title: 'History is the home address – Andrew Tshabangu',
          timestamp: '03:11:51',
          time: 11511
        },
        {
          title: "The devil's playground – Lavar Munroe'",
          timestamp: '03:21:39',
          time: 12099
        },
        {
          title: 'Babel en los tiempos del cólera – Arnaud Cohen ',
          timestamp: '03:27:06',
          time: 12426
        }
      ]
    }
  },
  methods: {
    ready(event) {
      this.player = event.target
    },
    seekTo(time) {
      this.player.seekTo(time)
      window.scrollTo(0, 0)
      this.expandNews = false
    },
    scrollDown() {
      window.scrollTo(0, 500)
    },
    async goToStudio() {
      await this.$store.dispatch('removeToken')
      this.$router.push('/studios')
      
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.tour-container {
  height: 80vh !important;
}
.tour-content {
  width: 100%;
  height: 92vh;
}
.video-tour {
  iframe {
    width: 100%;
    height: 92vh !important;
  }
}
.tour-studio {
  background: $color-black;
  width: 100%;
  min-height: 20vh;
  
  position: absolute;
  right:0
}
.studio-tour {
  margin-top: 20px !important;
}
.studio-tour-button {
  width: 120px;
  height: 31px;
  margin-top: 10px !important;
  position: absolute !important;
  z-index: 19;
  top: 10%;
  right: 1%;
  font-size: 10px !important;
  font-weight: 500 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: $color-white;
  border-radius: 26.5px !important;
  background-image: linear-gradient(to left, #a30078, #6a0043) !important;
}
.vjs-big-play-button {
  position: absolute !important;
  top: 50% !important;
  left: 47% !important;
  background-color: $color-primary !important;
  border: none !important;
  border-radius: 15px !important;
}
.kabs-chapter {
  a {
    color: rgb(90, 90, 221) !important;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .md-list-item.md-inset .md-list-item-content {
    padding-left: 20px !important;
    width: 100%;
    word-break: break-all;
  }        
            

}
</style>
